import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  constructor(private http: HttpClient) {}

  isFeatureEnabled(featureName: string) {
     // For localhost return this.http.get('http://localhost:3000/getconfig', {});
    return this.http.get('/getconfig', {}).pipe(
      map((data: any) => {
        if (data && data.feature_toggles) {
          return data.feature_toggles.includes(featureName);
        }
        return false;
      })
    );
  }
}
